import { Avatar } from "primereact/avatar"
import { Button } from "primereact/button"
import { OverlayPanel } from "primereact/overlaypanel"
import { Sidebar } from "primereact/sidebar"
import { useNavigate } from "react-router-dom"
import { MD5 } from 'crypto-js'
import * as auth from "infra/localStorage.js"
import { useEffect, useRef, useState } from "react"
import server from "infra/server"
import UsuarioCover from "business/cadastro/pessoa/usuarioCover/UsuarioCover"
import { errorToToast } from "helper/error"
import { Toast } from "primereact/toast"

export default function UserAvatar() {

    const navigate = useNavigate()
    const toast = useRef(null)
    const [perfilSidebar, setPerfilSidebar] = useState(false)
    const overlayRef = useRef(null)
    const storageData = auth.getData()
    const emailMd5 = MD5(storageData.usuario.email_usu)
    const [gravatar, setGravatar] = useState('')

    const handlePop = (event) => {
        overlayRef.current.toggle(event)
    }
    const handleOnHidePop = (data) => {
    }

    /* eslint-disable react-hooks/exhaustive-deps */
    useEffect(() => {
        if (!gravatar) {
            loadUserImg()
        }
    }, [gravatar])

    const loadUserImg = () => {

        server().get('cadastro/pessoa/usuariocover').then(async (response) => {

            if (response.data.pessoa_fisica.pessoa.ref_img_pes) {
                const imgUrl = `${auth.getData().bucketPath}/pessoa/${response.data.pessoa_fisica.pessoa.ref_img_pes}`
                setGravatar(imgUrl)
            }

        }).catch(err => {
            console.log(err)
            setGravatar(`https://www.gravatar.com/avatar/${emailMd5}`)
            errorToToast({ err, toast, alt: 'Erro desconhecido' })
        })

    }

    const logout = () => {
        server().post('/logout')
            .then(() => {
                auth.deleteToken()
                auth.clear()
                navigate('/login')
            }).catch(err => {
                errorToToast({ err, toast, alt: 'Erro ao sair! Redirecionado...' })
                setTimeout(() => navigate('/login'), 3000)
            })
    }

    return (
        <div>

            <Toast ref={toast} />

            <Avatar image={gravatar} shape="circle" size="small"
                onClick={handlePop}
                className="flex"
                style={{ borderRadius: 45 }}
            />
            <OverlayPanel
                className="grid mt-0"
                ref={overlayRef}
                appendTo={typeof window !== 'undefined' ? document.body : null}
                id="user_panel"
                onHide={handleOnHidePop}
            >
                <Button className="col-12" text onClick={(e) => setPerfilSidebar(true)} >Perfil</Button>
                <Button className="col-12" text onClick={logout}>Sair</Button>
            </OverlayPanel>
            <Sidebar className="" style={{ width: 400 }} visible={perfilSidebar} position="right" onHide={() => setPerfilSidebar(false)}>
                <h2>
                    Perfil
                </h2>
                <UsuarioCover
                    gravatar={gravatar}
                    setPerfilSidebar={setPerfilSidebar}
                    setGravatar={setGravatar}
                ></UsuarioCover>
            </Sidebar>
        </div >
    )

}